import type { Availability } from '@packages/gql/generated/shopping/graphql';

export const getIsAvailable = (state?: Availability['state']): boolean =>
  !!(state === 'AVAILABLE' || state === 'NOT_YET_AVAILABLE');
